import { FormHtml } from './FormHtmlInjector'

export const FormHtmlPrintEditor = props => {
  return <FormHtml {...props} />
}
